import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import corp_ads_ticket_ico from "@src/assets/deungi/corp_ads_ticket_ico.png";

import { useNavigate } from "react-router-dom";
import { useCorpTicketCount } from "@src/hooks/deungi/useTicketCount";

const CorpDeungiTicketBox = () => {
    const navigate = useNavigate();
    const [ticketCnt, setTicketCnt] = useState(0);

    const getTicketCount = async () => {
        await useCorpTicketCount().then((res) => {
            setTicketCnt(res.curHaveCnt || 0);
        });
    };

    const gotoPayment = () => {
        navigate("/corpDeungi/payment", { replace: false });
    };

    useEffect(() => {
        getTicketCount();
    }, []);

    return (
        <>
            <Container>
                <div>
                    <div className={"ticketItem active"} onClick={() => gotoPayment()}>
                        <img src={corp_ads_ticket_ico} />
                        <h3>
                            실시간 법인 등기열람권
                            <label>{ticketCnt}장</label>
                        </h3>
                    </div>
                </div>
            </Container>
            <div className="backDiv" />
        </>
    );
};

const Container = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    background: #fff;
    box-sizing: border-box;
    width: 100%;
    top: 55px;
    gap: 10px;
    padding: 0 14px 14px;
    z-index: 2;

    & > div {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 10px;
    }

    .ticketItem {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        background: #f6faff;
        border-radius: 8px;
        padding: 12px 8px;
        transition: all 0.2s ease;
        background: #0047ff;

        & > h3 {
            color: #fff;
            font-size: 13px;
            font-weight: 500;
            line-height: 1.4;
            min-width: 80px;
            width: max-content;
            text-align: center;
            margin: 4px auto 0;

            & > label {
                display: block;
                font-size: 14px;
                font-weight: 700;
                color: #fff;
                text-align: center;
            }
        }
        & > img {
            width: 38px;
            height: 38px;
            background: #fff;
            border-radius: 4px;
            padding: 6px;
            margin: auto;
        }
    }
`;

export default CorpDeungiTicketBox;
